import { css, cx } from "@emotion/css";
import { borderRadius, space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
export interface CodeDecoratorProps {
    value: string;
}
/**
 * CodeDecorator A styled inline code element for highlighting technical terms, commands, and snippets within text
 * @param {string} value - The value to display in the code decorator
 */
export function CodeDecorator({ value }: CodeDecoratorProps) {
    return <code className={cx(codeStyles)}>{value}</code>;
}
export default CodeDecorator;
// TODO: Design has a "Highlight" type, but no matching token
const codeStyles = css({
    font: text.code.regular.medium,
    backgroundColor: themeTokens.color.background.tertiary,
    borderRadius: borderRadius.small,
    padding: space[4],
    color: themeTokens.color.text.primary,
});
